import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { partnerEmployersSelectors } from '@ucheba/store/institutions/partner-employers'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { Banner } from '../../../../../../components/Banner/desktop'
import LayoutInstitution from '../../../../../../components/LayoutInstitution/desktop'

import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import PartnerEmployersList from './PartnerEmployersList'
import EmptyListPlaceholder from '../../../../components/EmptyListPlaceholder'
import GraduatesJob from '../../../../../../components/InstitutionGraduatesJob/desktop/InstitutionGraduatesJob'
import { isPaidPackage } from '../../utils/isPaidPackage'

const PartnersPage: FC = () => {
  const { items } = useSelector(partnerEmployersSelectors.entity) || {}
  const { companiesGraduateJobList } =
    useSelector(institutionItemSelectors.currentInstitution) || {}

  const { extraParams, paidPackage } = useBannerProgramTypes()

  return (
    <>
      <LayoutInstitution>
        {!!companiesGraduateJobList.length && (
          <>
            <GraduatesJob titleSize='h1' list={companiesGraduateJobList} />

            <Spacing spacing='uxlarge' />
          </>
        )}

        {items?.length && (
          <>
            <Heading as='h2' h2='Работодатели-партнеры' spacing='large' />

            <PartnerEmployersList />
          </>
        )}

        {!items?.length && !companiesGraduateJobList.length && (
          <EmptyListPlaceholder title='Учебное заведение пока не добавило работодателей-партнеров' />
        )}

        {!isPaidPackage(paidPackage) &&
          !items?.length &&
          companiesGraduateJobList.length && (
            <>
              <Spacing spacing='small' />

              <Banner id={2} extraParams={extraParams} />

              <Spacing spacing='small' />
            </>
          )}
      </LayoutInstitution>

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}

      {!isPaidPackage(paidPackage) && <Banner id={14} extraParams={extraParams} />}
    </>
  )
}

export default PartnersPage
